import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@mui/material';
import { observer } from 'mobx-react';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';

import classes from './TitleRow.module.scss';
import { customerActiveCalendarStore } from '../../../../../../stores/customerActiveCalendarStore';
import { DateSubTitle } from './DateSubTitle/DateSubTitle';
import { activeCalendarService } from '../../../../../../services/activeCalendarService';
import { printFile } from '../../../../../../../shared/utils/apiUtils';
import { PageTitle } from '../../../../../../../shared/components/ui-components';
import { LbUnderlineTabsList } from '../../../../../../../shared/components/tabs';

const { getScheduleFile } = activeCalendarService;

const TitleRow = observer(({ onEdit, customerId }) => {
  const { isActiveCalendarCreate, calendarForTomorrow } = customerActiveCalendarStore;

  const isShowCalendarsWithTabs = calendarForTomorrow.length !== 0;

  const handlerPrint = async () => {
    const { fileUrl } = await getScheduleFile(customerId);

    printFile(fileUrl);
  };

  const btnText = isActiveCalendarCreate ? 'Edit' : 'Create';

  return (
    <PageTitle
      title={
        <div className={classes.titleBox}>
          <span>Active Calendar</span>
          <span>
            <DateSubTitle />
          </span>
        </div>
      }
      tabs={
        !!isShowCalendarsWithTabs && (
          <LbUnderlineTabsList
            tabsConfig={[
              { label: 'Today', value: 0 },
              { label: 'Tomorrow', value: 1 },
            ]}
          />
        )
      }
    >
      <div>
        {isActiveCalendarCreate && (
          <Button
            variant="outlined"
            onClick={handlerPrint}
            startIcon={<PrintRoundedIcon />}
            className={classes.printBtn}
          >
            Print
          </Button>
        )}
        <Button variant="contained" onClick={onEdit}>
          {btnText}
        </Button>
      </div>
    </PageTitle>
  );
});

TitleRow.propTypes = {
  onEdit: PropTypes.func,
  customerId: PropTypes.string,
};

export { TitleRow };
